// Swiper Class
import Swiper from '/expert/mobile/core/core.js';

//IMPORT_MODULES

const modules = [
  //INSTALL_MODULES
];

Swiper.use(modules);

//EXPORT
